/* eslint-disable no-use-before-define */
import './tey-calculator.css'
import React from 'react'
import { $, hideModal, getState, publish, getConfig, subscribe, openWindow, showModal,  } from '../twd/twd'
import { Assumptions, Disclosures } from './footer'
import Input from './input'
import Search from './search'

subscribe('tey-calculator.tey-calculator', (args) => {

    if (getConfig('entitlements.ETradeTeyCalculator', 'No') === 'Yes') {
        showModal({
            view: 'tey-calculator',
            ...(args||{})
        })
        return
    }

    let url = 'https://us.etrade.com/speedbump/securities?target=https%3A%2F%2Fwww.broadridgeadvisor.com%2Fkt%2Ftrns.aspx%3Fil%3Det%26xsl%3Dinput%26xd%3Div-at-cl06-a02'
    let name = 'calculator'
    let options = 'toolbar=no,width=800,height=600,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no'
    openWindow(url, name, options)
})


export let getDefaultValues = () => {
    return {
        input: {
            bondProductType: '',
            bondYield: '',
            taxState: '',
            customTaxRate: '',
            federalTaxRate: '',
        },
        search: {
            searchFor: '',
            taxState: '',
            muniInStates: [],
            muniOutStates: [],
            holdMaturityMin: '',
            holdMaturityMax: '',
            callFeatures: [],
        },
    }
}

const state = getState('tey-calculator', {
      ...getDefaultValues(),
})

export const Context = React.createContext()

export const ContextProvider = ({children}) => {
    return (
    <Context.Provider value={{
        state,
        getDefaultValues,
    }}>
    {children}
    </Context.Provider>
    )
}

export const useTeyCalculator = () => React.useContext(Context)

export default (args) => {

    React.useEffect(() => {
        let tmId = setTimeout(() => {
            $('#modal :focusable').eq(0).focus()
        }, 200)

        return () => clearTimeout(tmId)
    }, [])

    let [calcTs, setCalcTs] = React.useState(null)

    return <React.Fragment>
    <div
        data-name="holdings-modal"
        className="modal-dialog modal-lg">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="holdings-modal-close"
                className="close"
                aria-label="Close"
                type="button"
                onClick={() => {
                    state.set({
                        ...(getDefaultValues()),
                    })
                    hideModal()
                }}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h2 className="modal-title text-center vertical-offset-sm">Tax-equivalent yields calculator</h2>

            <div className="tey-calculator-form container">
            <ContextProvider>
                <Input {...args} onCalcTs={setCalcTs} />
                <Search {...args} ts={calcTs} />
            </ContextProvider>
            </div>
        </div>


        <div className="modal-footer">
            <hr aria-hidden="true" className="vertical-offset-sm"></hr>
            <Assumptions />
            <Disclosures />
        </div>
    </div>
    </div>

    </React.Fragment>
}

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError:false }
    }
    static getDerivedStateFromError(error) {
        return {hasError:true}
    }
    componentDidCatch(error) {
        console.log('ERROR', error)
    }
    render() {
        if (this.state.hasError) {
            // eslint-disable-next-line
            this.state.hasError = false

            setTimeout(() => publish('error-boundary'))
            return null
        }
        return this.props.children
    }
}


// WEBPACK FOOTER //
// ./src/tey-calculator/tey-calculator.js